import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './order-number.hooks';

@Component({
	selector: 'app-order-number',
	templateUrl: './order-number.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class OrderNumberComponent {
	testHooks = TestHooks;
	@ViewSelectSnapshot(SelectedMatter.titleInsuranceReferenceNumber)
	referenceNumber: string;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Input() labelClass = '';

	constructor(private matterDispatch: MatterDispatch) {}

	setReferenceNumber(value: string): void {
		this.matterDispatch.SetTitleInsuranceReferenceNumber(this.matterId, value);
	}
}
